import React, { useContext, useState, useRef } from 'react'
import { pRecordTime } from '../utils/parameters';

const VideoSyncMonitorContext = React.createContext();

export function useVideoSyncMonitor() {
    return useContext(VideoSyncMonitorContext)
}

export function VideoSyncMonitor({ children }) {

    const [isPlayingRecorder, setIsPlayingRecorder] = useState(false)
    const [forceStartVideoRecorder, setForceStartVideoRecorder] = useState(0);
    const [forceStopVideoRecorder, setForceStopVideoRecorder] = useState(0);
    const [forceCurrentTimeVideoRecorder, setCurrentTimeVideoRecorder] = useState(0);

    const [isPlayingReference, setIsPlayingReference] = useState(false) 
    const [forceStartVideoReference, setForceStartVideoReference] = useState(0);
    const [forceStopVideoReference, setForceStopVideoReference] = useState(0);
    const [forceCurrentTimeVideoReference, setCurrentTimeVideoReference] = useState(0);

    const [isLoadedReference, setIsLoadedReference] = useState(false) 

    const [isLoopVideoRecorder, setIsLoopVideoRecorder] = useState(true)


    /* Exported values */
    const value = {

        isPlayingRecorder,
        setIsPlayingRecorder,
        isPlayingReference,
        setIsPlayingReference,

        isLoadedReference,
        setIsLoadedReference,

        forceStartVideoRecorder,
        setForceStartVideoRecorder,
        forceStopVideoRecorder,
        setForceStopVideoRecorder,
        forceCurrentTimeVideoRecorder,
        setCurrentTimeVideoRecorder,
        
        forceStartVideoReference,
        setForceStartVideoReference,
        forceStopVideoReference,
        setForceStopVideoReference,
        forceCurrentTimeVideoReference,
        setCurrentTimeVideoReference,

        isLoopVideoRecorder,
        setIsLoopVideoRecorder
        
    }

    return (
        <VideoSyncMonitorContext.Provider value={value}>
            {children}
        </VideoSyncMonitorContext.Provider>
    )
}
